// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--jgkpW";
export var btnBlock = "banner-module--btnBlock--BmxyW";
export var container = "banner-module--container--5RlKQ";
export var hideMobBlock = "banner-module--hideMobBlock--St49X";
export var img = "banner-module--img--RnqJz";
export var mobBtn = "banner-module--mobBtn--wzTos";
export var secondContainer = "banner-module--secondContainer--copO4";
export var section = "banner-module--section--11zu9";
export var text = "banner-module--text--4HYHx";